import { apiFetch } from './client'
import type { Round } from '@/types/bracket'

export interface RoundState {
  round: Round
  sort_order: number
  status: 'PENDING' | 'OPEN' | 'SCORED'
  opens_at: number | null
  lock_at: number | null
  scored_at: number | null
  effective_lock_at: number | null
  is_open_for_submission: boolean
}

export const fetchRounds = () =>
  apiFetch<{ rounds: RoundState[] }>('/rounds').then(r => r.rounds)
